/** Error body the backend returns when the destination org needs a fresh SSO login. */
export const SSO_REQUIRED_ERROR = "sso_required";

const FORBIDDEN_STATUS = 403;
const CONFLICT_STATUS = 409;
const DEFAULT_SWITCH_MESSAGE =
  "Could not switch organizations. Please try again.";

/** Raised when switching the session to another organization fails. */
export class SwitchOrganizationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "SwitchOrganizationError";
  }
}

/** True when the switch failed only because the destination org requires signing in again. */
export function isSsoRequiredResponse(
  status: number,
  error: string | null,
): boolean {
  return status === CONFLICT_STATUS && error === SSO_REQUIRED_ERROR;
}

/**
 * Maps a failed switch response onto an error whose message is safe to render.
 * @param failure - The response status and error, or null when the request never completed
 * @returns The error to surface to the user
 */
export function toSwitchOrganizationError(
  failure: { status: number; error: string | null } | null,
): SwitchOrganizationError {
  if (!failure) {
    return new SwitchOrganizationError(DEFAULT_SWITCH_MESSAGE);
  }
  if (failure.status === FORBIDDEN_STATUS) {
    return new SwitchOrganizationError(
      "You no longer have access to that organization.",
    );
  }
  return new SwitchOrganizationError(failure.error ?? DEFAULT_SWITCH_MESSAGE);
}
